/**
 * This file addresses introspection issues in Apollo
 * https://github.com/awslabs/aws-mobile-appsync-sdk-js/issues/70
 * https://github.com/awslabs/aws-mobile-appsync-sdk-js/pull/96
 * https://www.apollographql.com/docs/react/advanced/fragments
 * https://stackoverflow.com/questions/55297699/readfragment-causing-introspectionfragmentmatcher-error-although-not-using-inter/55450050#55450050
 */

// Run this query in GraphiQL in AWS and set response into 'fragmentTypes' below
// {
//   __schema {
//     types {
//       kind
//       name
//       possibleTypes {
//         name
//       }
//     }
//   }
// }

const fragmentTypes = {
  data: {
    __schema: {
      types: [
        {
          kind: 'INTERFACE',
          name: 'Field',
          possibleTypes: [
            {
              name: 'NumericField'
            },
            {
              name: 'ValuesListField'
            },
            {
              name: 'TextField'
            },
            {
              name: 'AttachmentField'
            },
            {
              name: 'DateField'
            }
          ]
        },
        {
          kind: 'INTERFACE',
          name: 'TemplateField',
          possibleTypes: [
            {
              name: 'TemplateNumericField'
            },
            {
              name: 'TemplateValuesListField'
            },
            {
              name: 'TemplateTextField'
            },
            {
              name: 'TemplateAttachmentField'
            },
            {
              name: 'TemplateDateField'
            }
          ]
        }
      ]
    }
  }
};

function normalize() {
  const fragmentTypesCopy = JSON.parse(JSON.stringify(fragmentTypes));
  const filteredData = fragmentTypesCopy.data.__schema.types.filter(type => type.possibleTypes !== null);
  fragmentTypesCopy.data.__schema.types = filteredData;
  return fragmentTypesCopy.data;
}

export default normalize();
